"use strict";
/**
 * Common constants used across applications
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BYPASS_CACHE = void 0;
/**
 * URL parameter name used for cache busting
 */
exports.BYPASS_CACHE = 'bypassCache';
